import $api from "../http";
import { AxiosResponse } from "axios";

export default class DistantService {

    static createDistantParticipant(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/distant/participant/', data)
    };

    static deleteDistantParticipant(id: number): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/distant/participant/${id}`)
    };

    static getDistantParticipant(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/distant/participant/')
    };

    static getAllDistantParticipants(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/distant/')
    };

    static createAvatar(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/distant/avatar/', data)
    };

    static getAvatar(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/distant/avatar/')
    };

};